import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import { HelpIconButton } from '@form/components/HelpIconButton/HelpIconButton.component';
import { useTranslation } from '@locales/useTranslation.hook';

import './MetricsHelpIconButton.scss';

interface Props extends ComponentPropsWithRef<'button'> {
  title?: string;
  popupDescriptionI18nKey?: string;
  popupTitleI18nKey?: string;
  children?: string;
  timeframe?: 'PT0S' | 'PT3H';
}

const MetricsHelpIconButton: FC<Props> = ({
  popupTitleI18nKey,
  popupDescriptionI18nKey,
  timeframe,
  children,
  ...rest
}) => {
  const { t } = useTranslation(['meteo']);
  const descI18nOptions = { timeframe: t(`meteo.metric.timeframe.${timeframe || 'unset'}`) as string };
  return (
    <HelpIconButton popupTitleI18nKey={popupTitleI18nKey} {...rest}>
      <Text
        className="metrics-help-description"
        i18nKey={popupDescriptionI18nKey}
        i18nOptions={descI18nOptions}
        variant="p"
      >{children}</Text>
    </HelpIconButton>
  );
};

export { MetricsHelpIconButton };
